module.exports = __webpack_public_path__ + "img/bind-success-code.57fbb662.jpg";